import React from 'react';
import './SudokuBombGame.css';
import SudokuBoard from './SudokuBoard';

const SudokuBombGame = ({ 
  board, 
  onCellClick, 
  isLoading, 
  removableCells 
}) => {
  return (
    <div className="bomb-game">
      <div className="bomb-game-header">
        <h2>数独危機一髪</h2>
        <p className="bomb-instructions">
          安全に数字を消せるマスを1つ選んでください。
          正解は{removableCells.length}個あります。
        </p>
      </div>
      
      <SudokuBoard 
        board={board} 
        onCellClick={onCellClick} 
        isLoading={isLoading}
        bombMode={true}
      />
    </div>
  );
};

export default SudokuBombGame;